<ix-fieldset [title]="'Authentication' | translate" [formGroup]="form">
  <ix-input
    formControlName="user"
    [label]="'Username' | translate"
    [required]="true"
    [tooltip]="helptext.user_mega.tooltip | translate"
  ></ix-input>

  <ix-input
    formControlName="pass"
    type="password"
    [required]="true"
    [label]="'Password' | translate"
    [tooltip]="helptext.pass_mega.tooltip | translate"
  ></ix-input>
</ix-fieldset>
